import {Messages} from 'ApplicationEntry/models/Messages';
import * as M from 'ApplicationEntry/models/Messages';
import {InvalidModalApplication, ValidModalApplication} from 'ApplicationEntry/models/ModalApplication';
import {Async, Loading} from 'Core/models/Async';
import {createAction} from 'Shared/utilities/actionCreator';
import {reverseEnum} from 'Shared/utilities/enumUtility';

import {WorkQueueItem} from 'ApplicationEntry/models/WorkQueueItem';

export enum MessagesActionType {
  CHANGE_AUE_MESSAGE = 'messages/CHANGE_AUE_MESSAGE',
  CHANGE_LIFE70_MESSAGE = 'messages/CHANGE_LIFE70_MESSAGE',
  SAVE = 'messages/SAVE',
  AWD_SAVE = 'messages/AWD_SAVE',
  UPDATE = 'messages/UPDATE',
  VALIDATE_AUE = 'messages/VALIDATE_AUE',
}

export const isMessagesAction = (action: any): action is MessageAction =>
  action.type in reverseEnum(MessagesActionType);

export const changeAUEMessage = (message: Async<object[]>) =>
  createAction(MessagesActionType.CHANGE_AUE_MESSAGE, {message});
export const changeLife70ErrorMessage = (message: Async<object[]>) =>
  createAction(MessagesActionType.CHANGE_LIFE70_MESSAGE, {message});

export const saveApplication = (
  application: ValidModalApplication | InvalidModalApplication,
  workQueueItems: WorkQueueItem[],
  awdSave: boolean
) => {
  if (awdSave) {
    return createAction(MessagesActionType.AWD_SAVE, {application, workQueueItems});
  } else {
    return createAction(MessagesActionType.SAVE, {application, workQueueItems});
  }
};

export const updateApplication = (application: ValidModalApplication | InvalidModalApplication, awdWorkKeyId: string) =>
  createAction(MessagesActionType.UPDATE, {application, awdWorkKeyId});
export const validateAUE = (application: ValidModalApplication | InvalidModalApplication) =>
  createAction(MessagesActionType.VALIDATE_AUE, {application});

export type MessageAction =
  | ReturnType<typeof changeAUEMessage>
  | ReturnType<typeof changeLife70ErrorMessage>
  | ReturnType<typeof saveApplication>
  | ReturnType<typeof updateApplication>
  | ReturnType<typeof validateAUE>;

type MessagesState = Messages;

export default (state: MessagesState, action: MessageAction) => {
  switch (action.type) {
    case MessagesActionType.SAVE:
      return M.changeLife70ErrorMessages(new Loading())(state);
    case MessagesActionType.AWD_SAVE:
      return M.changeLife70ErrorMessages(new Loading())(state);
    case MessagesActionType.UPDATE:
      return M.changeLife70ErrorMessages(new Loading())(state);
    case MessagesActionType.VALIDATE_AUE:
      return M.changeAUEErrorMessages(new Loading())(state);
    case MessagesActionType.CHANGE_AUE_MESSAGE:
      return M.changeAUEErrorMessages(action.payload.message)(state);
    case MessagesActionType.CHANGE_LIFE70_MESSAGE:
      return M.changeLife70ErrorMessages(action.payload.message)(state);
    default:
      return state;
  }
};
